// extracted by mini-css-extract-plugin
module.exports = {"primaryButton":"Badge-primaryButton-rH3YHp","badge":"Badge-badge-1hH4Zx"};